import { render, staticRenderFns } from "./FaceMenuComponent.vue?vue&type=template&id=a914e0c6&scoped=true&"
import script from "./FaceMenuComponent.vue?vue&type=script&lang=js&"
export * from "./FaceMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./FaceMenuComponent.vue?vue&type=style&index=0&id=a914e0c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a914e0c6",
  null
  
)

export default component.exports